import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BitbotError = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 5.20001C12.5523 5.20001 13 4.7523 13 4.20001C13 3.64773 12.5523 3.20001 12 3.20001C11.4477 3.20001 11 3.64773 11 4.20001C11 4.7523 11.4477 5.20001 12 5.20001Z"
      fill="currentColor"
    />
    <path
      d="M6.58586 13L5.29297 11.7071L6.70718 10.2929L8.00008 11.5858L9.29297 10.2929L10.7072 11.7071L9.41429 13L10.7072 14.2929L9.29297 15.7071L8.00008 14.4142L6.70718 15.7071L5.29297 14.2929L6.58586 13Z"
      fill="currentColor"
    />
    <path
      d="M14.5859 13L13.293 11.7071L14.7072 10.2929L16.0001 11.5858L17.293 10.2929L18.7072 11.7071L17.4143 13L18.7072 14.2929L17.293 15.7071L16.0001 14.4142L14.7072 15.7071L13.293 14.2929L14.5859 13Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1667 6.42355C14.4127 6.12979 9.51446 6.12979 5.76043 6.42355C4.42941 6.52771 3.368 7.51916 3.11809 8.79927C2.49661 11.9827 2.11965 14.3632 2.00285 17.0152C1.93388 18.581 3.12558 19.8973 4.68172 20C8.78945 20.271 15.1377 20.271 19.2454 20C20.8015 19.8973 21.9932 18.581 21.9243 17.0152C21.8075 14.3632 21.4305 11.9827 20.8091 8.79927C20.5592 7.51916 19.4978 6.52771 18.1667 6.42355ZM5.91645 8.41746C9.56663 8.13182 14.3605 8.13182 18.0107 8.41746C18.4155 8.44913 18.7624 8.75376 18.8461 9.18248C19.4612 12.3331 19.816 14.5995 19.9262 17.1032C19.947 17.5747 19.5925 17.9728 19.1138 18.0043C15.0937 18.2695 8.83343 18.2695 4.81336 18.0043C4.33462 17.9728 3.98014 17.5747 4.00091 17.1032C4.11118 14.5995 4.46596 12.3331 5.08103 9.18248C5.16473 8.75376 5.51168 8.44913 5.91645 8.41746Z"
      fill="currentColor"
    />
  </Icon>
));

export default BitbotError;
